// Formatting helpers for EVM deposit UI
// Keep these functions pure (no side effects) and UI-agnostic except for explicit JSX returns.
// If you need i18n or theme-aware strings, pass them in as parameters instead of importing here.

import { formatAmount } from '../../../utils'

/**
 * Build a user-friendly balance preview string/element.
 * When user has input an amount (> 0), show a "balance → remaining" indicator.
 * Otherwise show the full balance with token symbol.
 *
 * @param currentTokenBalance Current wallet balance for the token (string|number)
 * @param depositAmount The user-entered deposit amount (string|number)
 * @param selectedToken Token symbol to display (e.g., 'USDT')
 * @returns JSX element or string representing formatted balance preview
 */
export const formatBalanceDisplay = (
  currentTokenBalance: string | number,
  depositAmount: string | number,
  selectedToken: string
) => {
  const balance = parseFloat(String(currentTokenBalance) || '0')
  const inputAmount = parseFloat(String(depositAmount) || '0')

  if (inputAmount > 0) {
    const remainingBalance = balance - inputAmount

    const formattedRemaining = formatAmount(
      Math.max(0, remainingBalance).toString()
    )
    return (
      <span className="flex items-center gap-1">
        {formatAmount(currentTokenBalance || '0')}
        <span className="text-sm font-edgex-harmony text-functional-green-1 leading-[18px] font-medium">
          →
        </span>
        {formattedRemaining} {selectedToken}
      </span>
    )
  }

  return `${formatAmount(currentTokenBalance || '0')} ${selectedToken}`
}
